import React from "react";
import CountUp from "react-countup";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";

const Stats = () => {
  const { t } = useLang();

  return (
    <section data-testid="stats-section" className="py-20 md:py-28 bg-[#141414] text-[#F5F2EB]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <Kicker className="text-[#C4A27A]">{t.stats.kicker}</Kicker>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-y-12 gap-x-6 mt-12">
          {t.stats.items.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="border-t border-white/15 pt-6">
                <div className="font-display text-4xl md:text-5xl lg:text-6xl text-white tracking-tight">
                  <CountUp
                    end={s.value}
                    duration={2.4}
                    separator=","
                    enableScrollSpy
                    scrollSpyOnce
                  />
                  <span className="text-[#C4A27A]">{s.suffix}</span>
                </div>
                <p className="mt-3 text-sm md:text-base text-[#A8A296] leading-snug">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
